/**
 * API — Mensajes generales / Parámetros de correo (Despacho).
 */
import api from "@/lib/api";

export const despachoMensajesGeneralesApi = {
  async list({ messageKind } = {}) {
    const { data } = await api.get("/despacho/mensajes-generales", {
      params: messageKind ? { message_kind: messageKind } : undefined,
    });
    return data;
  },

  async getEmailConfig() {
    const { data } = await api.get("/despacho/mensajes-generales/email-config");
    return data?.config || {};
  },

  async putEmailConfig(body) {
    const { data } = await api.put("/despacho/mensajes-generales/email-config", body);
    return data?.config || {};
  },

  async getOAuthProviders() {
    const { data } = await api.get("/despacho/mensajes-generales/email-config/oauth/providers");
    return data?.providers || {};
  },

  async startOAuth(provider) {
    const { data } = await api.post(`/despacho/mensajes-generales/email-config/oauth/${provider}/start`);
    return data;
  },

  async disconnectOAuth() {
    const { data } = await api.delete("/despacho/mensajes-generales/email-config/oauth/disconnect");
    return data?.config || {};
  },

  async testSmtp({ smtpPassword, usePlatformSmtp } = {}) {
    const body = { smtp_password: smtpPassword || undefined };
    if (usePlatformSmtp != null) {
      body.use_platform_smtp = Boolean(usePlatformSmtp);
    }
    const { data } = await api.post("/despacho/mensajes-generales/email-config/test-smtp", body);
    return data;
  },

  async uploadBrandImage(file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/despacho/mensajes-generales/email-config/brand-image", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async deleteBrandImage() {
    const { data } = await api.delete("/despacho/mensajes-generales/email-config/brand-image");
    return data;
  },

  brandImageUrl() {
    return "/api/despacho/mensajes-generales/email-config/brand-image";
  },

  async create(body) {
    const { data } = await api.post("/despacho/mensajes-generales", body);
    return data;
  },

  async get(messageId) {
    const { data } = await api.get(`/despacho/mensajes-generales/${messageId}`);
    return data;
  },

  async update(messageId, body) {
    const { data } = await api.put(`/despacho/mensajes-generales/${messageId}`, body);
    return data?.item;
  },

  async remove(messageId) {
    const { data } = await api.delete(`/despacho/mensajes-generales/${messageId}`);
    return data;
  },

  async refreshRecipients(messageId) {
    const { data } = await api.post(`/despacho/mensajes-generales/${messageId}/refresh-recipients`);
    return data;
  },

  async patchRecipient(messageId, recipientId, body) {
    const { data } = await api.patch(
      `/despacho/mensajes-generales/${messageId}/recipients/${recipientId}`,
      body,
    );
    return data?.item;
  },

  async dispatch(messageId, body = {}) {
    const { data } = await api.post(`/despacho/mensajes-generales/${messageId}/dispatch`, body);
    return data;
  },

  async resend(messageId, recipientId, { dryRun = false } = {}) {
    const { data } = await api.post(
      `/despacho/mensajes-generales/${messageId}/recipients/${recipientId}/resend`,
      null,
      { params: { dry_run: dryRun } },
    );
    return data;
  },

  async listTemplates({ q = "", activeOnly = true, messageKind } = {}) {
    const { data } = await api.get("/despacho/mensajes-generales/templates", {
      params: {
        q: q || undefined,
        active_only: activeOnly,
        ...(messageKind ? { message_kind: messageKind } : {}),
      },
    });
    return data;
  },

  async createTemplate(body) {
    const { data } = await api.post("/despacho/mensajes-generales/templates", body);
    return data;
  },

  async updateTemplate(templateId, body) {
    const { data } = await api.put(`/despacho/mensajes-generales/templates/${templateId}`, body);
    return data;
  },

  async duplicateTemplate(templateId) {
    const { data } = await api.post(`/despacho/mensajes-generales/templates/${templateId}/duplicate`);
    return data;
  },

  async removeTemplate(templateId) {
    const { data } = await api.delete(`/despacho/mensajes-generales/templates/${templateId}`);
    return data;
  },

  async listFreeSendClients() {
    const { data } = await api.get("/despacho/mensajes-generales/free-send/clients");
    return data;
  },

  async sendFreeEmail(body) {
    const { data } = await api.post("/despacho/mensajes-generales/free-send", body);
    return data;
  },
};

export function parseMensajesGeneralesError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return { message: detail };
  if (detail?.message) return { message: detail.message, code: detail.code };
  return { message: err?.message || "Error en mensajes generales" };
}
